import React from "react";

// ✅ Replace these with your real images
import img1 from "../../Images/Capture.PNG";
import img2 from "../../Images/automatische-followups-image-only-NO-TEXT.png";
import img3 from "../../Images/email-whatsapp-integration-image-only.png";
import img4 from "../../Images/rollen-rechteverwaltung-image-only.png";

const solutions = [
  {
    title: "Automatisiertes Marketing & Sichtbarkeit",
    img: img1,
    size: "big", // 2/3
    items: [
      {
        name: "KI-gestütztes Social Media Marketing",
        points: ["Content- & Videoerstellung", "Reichweite für Kunden & Mitarbeitergewinnung"],
      },
      {
        name: "Automatischer Blogersteller",
        points: ["Branchen- & zielgruppenspezifisch", "Mehr organische Anfragen ohne Paid Ads"],
      },
    ],
  },
  {
    title: "Leadgenerierung & Vertrieb",
    img: img2,
    size: "small", // 1/3
    items: [
      {
        name: "E-Mail-Marketing Kampagnen (vollautomatisch)",
        points: [],
      },
      {
        name: "KI-Voice-Agenten",
        points: ["Inbound Kundenberatung", "Lead-Qualifizierung", "Keine verpassten Anrufe mehr"],
      },
    ],
  },
  {
    title: "KI-Agenten für Abteilungen",
    img: img4,
    size: "small", // 1/3
    items: [
      { name: "Marketing-Agent", points: [] },
      { name: "Sales-Agent", points: [] },
      { name: "Support-Agent", points: [] },
      { name: "HR-Agent", points: [] },
      { name: "Interner Wissens-Agent", points: [] },
    ],
  },
  {
    title: "Betriebs- & Verwaltungsautomatisierung",
    img: img3,
    size: "big", // 2/3
    items: [
      { name: "Angebots- & Rechnungserstellung", points: [] },
      { name: "Automatische Datenerfassung", points: ["PDFs & E-Mails auslesen"] },
      { name: "Meeting-Protokollierung", points: [] },
      { name: "Mitarbeiter-Onboarding Prozesse", points: [] },
      { name: "Interne KI-Wissenssysteme", points: [] },
    ],
  },
];

function SolutionCard({ title, img, items, className = "" }) {
  return (
    <div
      className={
        "group rounded-2xl border border-black/5 bg-white/90 p-5 shadow-[0_10px_30px_rgba(15,23,42,0.08)] backdrop-blur-md transition hover:shadow-[0_16px_45px_rgba(15,23,42,0.12)] " +
        className
      }
    >
      {/* Top */}
      <div className="flex items-center gap-4">
        <div className="flex h-[58px] w-[58px] items-center justify-center overflow-hidden rounded-2xl bg-gradient-to-b from-slate-50 to-white border border-black/5">
          <img src={img} alt={title} className="h-full w-full object-contain p-2" draggable="false" />
        </div>
        <h3 className="text-[18px] font-semibold leading-tight tracking-tight text-[#0B2B40] 2xl:text-[20px]">
          {title}
        </h3>
      </div>

      {/* Timeline-ish list */}
      <div className="mt-5">
        <div className="relative pl-8">
          <div className="absolute left-[11px] top-1 bottom-1 w-px bg-black/10" />

          <div className="space-y-4">
            {items.map((it, i) => (
              <div key={i} className="relative">
                <div className="absolute left-[-14px] top-[8px] h-[22px] w-[22px] rounded-full bg-white border border-black/10 shadow-sm flex items-center justify-center">
                  <div className="h-[10px] w-[10px] rounded-full bg-[#BEE262]" />
                </div>

                <div className="rounded-xl border border-black/5 bg-slate-50/70 px-4 py-3">
                  <p className="font-semibold text-slate-900 text-sm">{it.name}</p>

                  {it.points?.length > 0 && (
                    <ul className="mt-2 space-y-1 text-sm text-slate-600 leading-relaxed">
                      {it.points.map((p, j) => (
                        <li key={j} className="flex items-start gap-2">
                          <span className="mt-[7px] inline-flex h-1.5 w-1.5 rounded-full bg-[#BEE262]" />
                          <span>{p}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Features() {
  return (
    <section className="w-full bg-white py-10 md:py-14">
      <div className="mx-auto w-[90%] 2xl:w-[70%]">
        <div className="relative overflow-hidden rounded-[28px] border border-black/5 bg-gradient-to-b from-slate-100 to-[#c9f567b3] px-5 py-8 shadow-[0_18px_60px_rgba(15,23,42,0.10)] md:px-10 md:py-10">
          {/* Header */}
          <div className="relative text-center">
            <p className="mx-auto inline-flex items-center rounded-full border border-black/10 bg-white/70 px-4 py-1 text-xs font-semibold tracking-wide text-slate-700">
              Service Overwie (Solutions)
            </p>

            <h2 className="mt-4 h2-mb h2-md h2-lg h2-2xl">
              Lösungen, die Prozesse automatisieren & Anfragen <br /> steigern
            </h2>
          </div>

          {/* Layout: 2/3 + 1/3, then 1/3 + 2/3 */}
          <div className="relative mt-7 block gap-5 md:mt-9 md:grid md:grid-cols-3">
            {/* Top-left big (2/3) */}
            <SolutionCard
              title={solutions[0].title}
              img={solutions[0].img}
              items={solutions[0].items}
              className="md:col-span-2 mt-4 md:mt-0"
            />

            {/* Top-right small (1/3) */}
            <SolutionCard
              title={solutions[1].title}
              img={solutions[1].img}
              items={solutions[1].items}
              className="md:col-span-1 mt-4 md:mt-0"
            />

            {/* Bottom-left small (1/3) */}
            <SolutionCard
              title={solutions[2].title}
              img={solutions[2].img}
              items={solutions[2].items}
              className="md:col-span-1 mt-4 md:mt-0"
            />

            {/* Bottom-right big (2/3) */}
            <SolutionCard
              title={solutions[3].title}
              img={solutions[3].img}
              items={solutions[3].items}
              className="md:col-span-2 mt-4 md:mt-0"
            />
          </div>

          {/* Bottom note */}
          
        </div>
      </div>
    </section>
  );
}
